import { render, staticRenderFns } from "./seller.vue?vue&type=template&id=a372e078&scoped=true"
import script from "./seller.vue?vue&type=script&lang=ts"
export * from "./seller.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a372e078",
  null
  
)

export default component.exports